<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IDMIkN/tc-custom/scover.jpg" alt="This image is the cover for the book God, the Invisible King, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">God, the Invisible King, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Perhaps all religions, unless the flaming onset of Mohammedanism be an exception, have dawned imperceptibly upon the world. A little while ago and the thing was not; and then suddenly it has been found in existence, and already in a state of diffusion. People have begun to hear of the new belief first here and then there. It is interesting, for example, to trace how Christianity drifted into the consciousness of the Roman world. But when a religion has been interrogated it has always had hitherto a tale of beginnings, the name and story of a founder. The renascent religion that is now taking shape, it seems, had no founder; it points to no origins. It is the Truth, its believers declare; it has always been here; it has always been visible to those who had eyes to see. It is perhaps plainer than it was and to more people-that is all. It is as if it still did not realise its own difference. Many of those who hold it still think of it as if it were a kind of Christianity. Some, catching at a phrase of Huxley's, speak of it as Christianity without Theology. They do not know the creed they are carrying. It has, as a matter of fact, a very fine and subtle theology, flatly opposed to any belief that could, except by great stretching of charity and the imagination, be called Christianity. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. G. Wells
      </h2>
      
      <p class="authorDescription body article">Herbert George Wells; (21 September 1866 – 13 August 1946) was an English writer. Prolific in many genres, he wrote dozens of novels, short stories, and works of social commentary, history, satire, biography and autobiography. His work also included two books on recreational war games. Wells is now best remembered for his science fiction novels and is often called the "father of science fiction", along with Jules Verne and the publisher Hugo Gernsback.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7498538a